import { Box, Img,} from '@chakra-ui/react'
import React from 'react'
import { Link} from 'react-scroll'

export const Navbar = () => {
  return (
    <Box display={{xs: 'flex',sm: 'flex', md:'none',lg:'none'}} 
    width={{xs:'100%', sm:'100%',lg:'none'}} 
    bottom='0' 
    left={'0'} 
    right='0' 
    height='40px' 
    margin={'auto'}
    justifyContent={'space-evenly'}
    alignItems={'center'} 
    position={'fixed'} 
    borderTop={'1px solid black'}
    background={'#E7FFC9'}
    boxShadow={'0px 0px 4px rgba(0, 0, 0, 0.04), 0px -8px 16px rgba(0, 0, 0, 0.08)'}
    zIndex='999'
    >
       
       <Link to='About'>
        <Img width={'1.5rem'} height={'1.5rem'} src={'/assets/user-regular.svg'}/>
       </Link>
        <Link to='Work'>
        <Img width={'1.5rem'} height={'1.5rem'} src={'/assets/handshake-regular.svg'}/>
        </Link>
        <Link to='Pricing'>
        <Img width={'1.5rem'} height={'1.5rem'} src={'/assets/comment-dollar-solid.svg'}/>
        </Link>
        <Link to='Contact'>
        <Img width={'1.5rem'} height={'1.5rem'} src={'/assets/envelope-regular.svg'}/>
        </Link>
    </Box>
  )
}
